// Smooth-scroll to a section id, accounting for the sticky header height.
// Respects prefers-reduced-motion.
export const HEADER_OFFSET = 88;

export function scrollToId(id) {
  if (!id) return;
  const target = document.getElementById(id);
  if (!target) return;
  const prefersReduced = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;
  const top =
    target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
  window.scrollTo({ top, behavior: prefersReduced ? "auto" : "smooth" });
  // Move focus for accessibility without an extra visible jump.
  target.setAttribute("tabindex", "-1");
  window.setTimeout(() => target.focus({ preventScroll: true }), prefersReduced ? 0 : 450);
}
